<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      推荐<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">推荐基本信息</td>
        </tr>
        <tr>
          <td class="left_td pt30">标题：</td>
          <td class="pt20"><input type="text" name="title" v-validate="'required'" placeholder="请输入标题" class="put_495" v-model="form.title" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.title') }}</div>
        <tr>
          <td class="left_td">链接：</td>
          <td>
            <input type="text" name="href" v-model="form.href" placeholder="请输入链接" class="put_495"/>
            <select name="enrollType" class="all_select" v-model="internalLinkType">
              <option value="1">计划</option>
              <option value="2">课程</option>
              <option value="3">报名</option>
              <option value="4">文章</option>
            </select>
            <div class="all_btn" style="display: inline-block;" v-if="internalLinkType == '1'" @click="show3">+ 选择计划</div>
            <div class="all_btn" style="display: inline-block;" v-if="internalLinkType == '2'" @click="show1">+ 选择课程</div>
            <div class="all_btn" style="display: inline-block;" v-if="internalLinkType == '3'" @click="show2">+ 选择报名</div>
            <div class="all_btn" style="display: inline-block;" v-if="internalLinkType == '4'" @click="show4">+ 选择文章</div>
            <p class="mt10"><span class="tips_text">外部链接: http://xxx.com; 内部链接: 选择一种内部资源</span></p>
          </td>
        </tr>
        <!--<div class="error_msg">{{ errors.first('form.href') }}</div>-->
        <tr>
          <td class="left_td " valign="top">排序：</td>
          <td><input type="text" name="sort" v-validate="'required'" placeholder="请输入排序" class="put_495" style="width:180px;" v-model="form.sort" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.sort') }}</div>
        <tr>
          <td class="left_td " valign="top">上传文件：</td>
          <td>
            <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'cover'" v-if="uploadOSSConf.STS!=null" @success = "OSSUploadSuccess"></UploadOSS>
          </td>
        </tr>
        <tr v-if="form.cover && form.cover!=''">
          <td class="left_td " valign="top">文件地址：</td>
          <td>
            <a href="javascript:;">{{form.cover}}</a>
          </td>
        </tr>
        <div class="error_msg">{{ errors.first('form.sort') }}</div>
        <tr>
          <td class="left_td">状态：</td>
          <td>
            <input name="audit" type="radio" value="0" v-model="form.audit"/>
            未通过　　　
            <input name="audit" type="radio" value="1" v-model="form.audit"/>
            通过</td>
        </tr>
        <tr>
          <td class="left_td" style="padding-top: 20px;" valign="top">描述：</td>
          <td valign="top" class="pt10"><textarea name="content" cols="" rows="" class="text_area w490" v-model="form.content"></textarea></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.content') }}</div>
      </table>
      <p class="btn_center mt50">
        <input name="" type="button" class="all_btn" value="提交完成" @click="validateForm('form')" />
      </p>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Bus from '@/utils/bus'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import planSelect from '@/page/byl/org/plan/select.vue'
  import CourseSelect from '@/page/byl/org/course/select.vue'
  import enrollSelect from '@/page/byl/org/enroll/select'
  import kbSelect from '@/page/byl/org/repo/select'
    export default {
      components: { UploadOSS },
      data () {
        return {
          form: {
            audit: '1',
            state: '1'
          },
          internalLinkType: '1',
          tmpList: [],
          uploadOSSConf: { showMode: '2', style: 'cert_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null },
          prefix: this.$route.meta.prefix || ''
        }
      },
      mounted () {
        this.getSTS()
        if (this.isEdit) { // 通过 id 取信息并且要给select赋值
          this.getModel(this.$route.params.id)
        }
        Bus.$on('set-selected-plan', (data) => {
          if (data.indexOf(',') > -1) {
            this.$toasted.show('一个链接只能对应一个计划')
          } else {
            this.$set(this.form, 'href', 'internalink/' + this.internalLinkType + '/' + data)
          }
        })
        Bus.$on('set-selected-enroll', (data) => {
          if (data.indexOf(',') > -1) {
            this.$toasted.show('一个链接只能对应一个报名')
          } else {
            this.$set(this.form, 'href', 'internalink/' + this.internalLinkType + '/' + data)
          }
        })
        Bus.$on('set-selected-kb', (data) => {
          if (data.indexOf(',') > -1) {
            this.$toasted.show('一个链接只能对应一篇文章')
          } else {
            this.$set(this.form, 'href', 'internalink/' + this.internalLinkType + '/' + data)
          }
        })
        Bus.$on('selectedCourses', (data) => {
          if (data.length > 1) {
            this.$toasted.show('一个链接只能对应一个课程')
          } else {
            this.$set(this.form, 'href', 'internalink/' + this.internalLinkType + '/' + data[0])
          }
        })
      },
      computed: {
        isEdit () {
          return this.$route.params.id && this.$route.params.id !== 'void'
        }
      },
      methods: {
        popup (msg) {
          this.$toasted.show(msg)
        },
        confirmBox (o) {
          var that = this
          this.$modal.show('dialog', {
            title: '提交',
            text: '确认提交吗？',
            buttons: [
              {
                title: '确认',
                default: true,
                handler: that.$utils.debounce(() => {
                  if (o.yes && o.yes instanceof Function) {
                    o.yes()
                    that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                  }
                }, 1000)
              },
              {
                title: '取消'
              }
            ]
          })
        },
        validateForm (scope) {
          var bus = this
          this.$validator.validateAll(scope).then(function (result) {
            if (result) {
              bus.confirmBox({
                yes: function () {
                  if (!bus.form.href || bus.form.href == '') {
                    bus.form.href = 'javascript:;'
                  }
                  api.post(config.bylBaseCenterPath, '/recommendinfo/save', bus.form, function (r) { // 正常
                    if (bus.isEdit) { // 编辑
                      bus.popup('保存成功')
                    } else {
                      bus.popup('推荐创建成功')
                    }
                    bus.$router.push(bus.prefix + '/org/bannerList')
                  })
                }
              })
            } else {
              bus.popup('请确保信息正确与完整')
              return false
            }
          })
        },
        to (path) {
          this.$router.push(path)
        },
        getModel (id) {
          var that = this
          api.post(config.bylBaseCenterPath, '/recommendinfo/get', {id: id}, function (r) { // 正常
            that.form = r.data
            that.$emit('data-prepared', that.form)
          })
        },
        OSSUploadSuccess (r) {
          if (r) {
            this.$set(this.form, r.dom_id, r.res.requestUrls[0])
          }
        },
        getSTS () {
          this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
            let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
            this.uploadOSSConf.STS = STS
          })
        },
        show1 () {
          this.$modal.show(CourseSelect, {
            ids: ''
          })
        },
        show2 () {
          this.$modal.show(enrollSelect, {
            ids: ''
          })
        },
        show3 () {
          this.$modal.show(planSelect, {
            ids: ''
          })
        },
        show4 () {
          this.$modal.show(kbSelect, {
            ids: ''
          })
        }
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/banner/model.vue